/* eslint-disable */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import { fontFamily, materialStyler } from '../FPSThemeWrapper/Styles';
import PhoneBannerBtn from './Buttons/PhoneBannerBtn';
import FaqBannerBtn from './Buttons/FaqBannerBtn';

const useStyles = makeStyles( theme => ({
    wrapper: materialStyler.cardMediaWrapper,
    button: {
        border: 'none',
        minWidth: 36
    },
    popover: {
        height: 100,
        padding: theme.spacingVars.xxmedium
    },
    popoverTextHeader: {
        fontSize: theme.fontVars.xsmall,
        color: '#414141',
        lineHeight: '16px',
        fontFamily: fontFamily.nimbusSansBold
    },
    popoverTextBody: {
        fontSize: theme.fontVars.medium,
        color: theme.palette.darkGray,
        lineHeight: theme.fontVars.mediumLH,
        fontFamily: theme.fontFamily.light
    },
    popoverLinks: {
        border: '1px solid #086EA1',
        color: theme.palette.interactiveBlue,
        fontFamily: fontFamily.nimbusSansReg,
        fontSize: theme.fontVars.xsmall,
        marginTop: 6,
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: theme.palette.white,
            textDecoration: 'none'
        }
    },
    popoverTelephoneLink: {
        border: '1px solid #086EA1',
        padding: '10px 16px',
        color: theme.palette.interactiveBlue,
        minWidth: '64px',
        boxSizing: 'border-box',
        fontFamily: theme.fontFamily.reg,
        fontSize: theme.fontVars.xsmall,
        marginTop: 6,
        fontWeight: 500,
        borderRadius: 4,
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: theme.palette.white,
            textDecoration: 'none'
        }
    },
    faqIcon: {
        fontSize: '.7rem !important',
        paddingLeft: 5,
        marginTop: '-4px'
    },
    tooltip: {}
}));

const Utils = () => {
    const classes = useStyles();

    return (
        <div className={classes.wrapper} id="banner-button-container">
            <Box display="flex" flexDirection="row">
                <PhoneBannerBtn classes={classes} />
                <FaqBannerBtn classes={classes} />
            </Box>
        </div>
    );
};

export default function BlueBannerUtils() {
    return (
        <div>
            <Utils />
        </div>
    );
}
